import axios from "axios";

import router from "../router";
import store from "../store";
const endpoint = "https://us-central1-api-springboard.cloudfunctions.net/";

const state = {
    app: null,
    schedule: null,
};

const mutations = {
    schedule(state, payload) {
        state.schedule = payload;
    },
    app(state, payload) {
        state.app = payload;
        if (router.history.current.name !== 'Home') {
            router.replace("/Home");
        }
        store.commit("loading", false)
    },
    updateTicket(state, payload) {
        if (payload.state == 'cancelado') {
            state.schedule.employees[payload.serverID].schedule[payload.date][payload.hour] = {
                state: 'disponible',
                time: payload.time,
                moment: payload.moment
            }
        } else {
            state.schedule.employees[payload.serverID].schedule[payload.date][payload.hour] = payload
        }
    }
};

const actions = {
    schedule({ commit }) {
        axios
            .get(endpoint + "scheduleNoCache", {
                params: {
                    license: store.getters.profile.license,
                    days: store.getters.app.schedule.days,
                    pastAdmin: store.getters.app.schedule.pastAdmin,
                },
            })
            .then((response) => { commit("schedule", response.data) }, error => {
                store.commit("messages", {
                    visible: true,
                    icon: "mdi-alert-circle-outline",
                    text: error.message,
                    color: "red"
                });
            })
    },

    app({ commit }) {
        axios
            .get(endpoint + "appNoCache", {
                params: {
                    license: store.getters.profile.license,
                },
            })
            .then((response) => {
                commit("app", response.data);
            }, error => {
                store.commit("messages", {
                    visible: true,
                    icon: "mdi-close",
                    text: error.message,
                    color: "red"
                });
            });
    },

    cancelReserve({ commit }) {
        store.commit("closed");
        const payload = store.getters.dataTicket
        payload.state = "cancelado"
        axios
            .get(endpoint + "cancelReserveNoCache", {
                params: {
                    license: store.getters.profile.license,
                    payload: JSON.stringify(payload)
                },
            })
            .then((response) => {
                commit("updateTicket", payload);
                store.commit("messages", {
                    visible: true,
                    icon: response.data.icon,
                    text: response.data.text,
                    color: response.data.color,
                });
            }, error => {
                store.commit("messages", {
                    visible: true,
                    icon: "mdi-alert-circle",
                    text: error.message,
                    color: "red",
                });
            })
    },
    confirmReserve({ commit }) {
        store.commit("closed");

        const payload = store.getters.dataTicket
        payload.state = "confirmado"
        axios
            .get(endpoint + "confirmReserveNoCache", {
                params: {
                    license: store.getters.profile.license,
                    payload: JSON.stringify(payload)
                },
            })
            .then((response) => {
                commit("updateTicket", payload);
                store.commit("messages", {
                    visible: true,
                    icon: response.data.icon,
                    text: response.data.text,
                    color: response.data.color,
                });
            }, error => {
                store.commit("messages", {
                    visible: true,
                    icon: "mdi-alert-circle",
                    text: error.message,
                    color: "red",
                });
            })
    },
    reserve({ commit }) {
        store.commit("closed");

        const payload = store.getters.dataTicket
        payload.state = "reservado"
        axios
            .get(endpoint + "reserveNoCache", {
                params: {
                    license: store.getters.profile.license,
                    payload: JSON.stringify(payload)
                },
            })
            .then((response) => {
                commit("updateTicket", payload);
                store.commit("messages", {
                    visible: true,
                    icon: response.data.icon,
                    text: response.data.text,
                    color: response.data.color,
                });
            }, error => {

                store.commit("messages", {
                    visible: true,
                    icon: "mdi-alert-circle",
                    text: error.message,
                    color: "red",
                });
            })
    }
};

const getters = {
    app: (state) => state.app,
    schedule: (state) => state.schedule,
    endpoint: () => "https://us-central1-api-springboard.cloudfunctions.net/"
};

export default {
    getters,
    mutations,
    actions,
    state,
};